let _confirmDialog = null;
let _infoDialog = null;

class AppMem {
	static get confirmDialog() {
		return _confirmDialog;
	}

	static set confirmDialog(value) {
		_confirmDialog = value;
	}

	static get infoDialog() {
		return _infoDialog;
	}

	static set infoDialog(value) {
		_infoDialog = value;
	}
}

module.exports = AppMem;



// WEBPACK FOOTER //
// ./src/common/AppMem.js